export default __webpack_public_path__ + "media/images/under_mainteance_small-570ebb203f57471e9a7ca2cc574f8142.jpg";